import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/helpers/data.service';
import { environment } from 'src/environments/environment.development';

@Component({
  selector: '[core-menu-horizontal-item]',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
})
export class CoreMenuHorizontalItemComponent implements OnInit {
  @HostBinding('class.item-component') hasClass = true;
  @Input()
  item: any;
  @Input()
  child?: boolean;

  class = '';
  iconPrefix = 'assets/images/icons/home/';

  constructor(private _dataServ: DataService) {}
  ngOnInit(): void {
    if (!this.child) this.class = 'justify-content-center px-1';
    if (this.item?.icon?.includes(environment.base_url)) this.iconPrefix = '';
  }
  handleExternalUrl() {
    if (this.item?.url) {
      if (this.item.openInNewTab) {
        window.open(this.item.url, '_blank');
      } else {
        window.location.href = this.item.url;
      }
    }
  }
}
